module.exports = __webpack_public_path__ + "static/media/webDevelopmentIcon.9b7e39e2.svg";